import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { useUpdatePersonCell } from '@/components/PersonListCell/hooks/useUserList';
import { FilterProvider } from '@/contexts/FilterContext';
import { CACHE_KEY_LIST_USER } from '@/modules/admin/contants/users';

import List from './List';

const PersonListCell = ({ filters, ...rest }) => {
  const { Provider, useList } = useUpdatePersonCell();
  
  return (<FilterProvider id={CACHE_KEY_LIST_USER} defaultFilter={filters}>
    <Provider>
      <List listHook={useList} canSearch {...rest}/>
    </Provider>
  </FilterProvider>);
};

PersonListCell.propTypes = {
  value: PropTypes.string,
  filters: PropTypes.object,
  onSubmit: PropTypes.func,
  multiple: PropTypes.bool,
  canSearch: PropTypes.bool,
  close: PropTypes.func
};

export default memo(PersonListCell);
